// John Eldhose 20180628
const AddToCart = (item) => ({
  type: 'ADD_TO_CART',
  item
});

export default AddToCart;



// WEBPACK FOOTER //
// ./src/actions/AddToCart.js